import { combineReducers } from 'redux';
import { RootAction } from '@src/app/_redux';
import { OMS_LOOKUP_SUCCESS } from '@src/app/login/oms/actions';
import {
  ORDER_UPDATE_LOADING,
  ORDER_UPDATE_SUCCESS,
  ORDER_UPDATE_ERROR,
  ORDER_UPDATE_CANCEL,
  ORDER_UPDATE_START,
  RESIN_ORDER_UPDATE_LOADING,
  RESIN_ORDER_UPDATE_SUCCESS,
  RESIN_ORDER_UPDATE_ERROR,
  RESIN_ORDER_UPDATE_START,
  RESIN_ORDER_UPDATE_CANCEL,
  CANCEL_STOP_AUTO_RENEW_START,
  CANCEL_STOP_AUTO_RENEW_SUCCESS,
  CANCEL_STOP_AUTO_RENEW_ERROR,
  CANCEL_STOP_AUTO_RENEW_LOADING,
  CANCEL_STOP_AUTO_RENEW_CANCEL,
  RESIN_ORDER_REFUND_LOADING,
  RESIN_ORDER_REFUND_SUCCESS,
  RESIN_ORDER_REFUND_ERROR,
  RESIN_ORDER_REFUND_START,
  RESIN_ORDER_REFUND_CANCEL,
} from '@src/app/accounts/orders';
import { SEND_CUSTSERV_EMAIL_SUCCESS, SEND_CUSTSERV_EMAIL_ERROR, SEND_CUSTSERV_EMAIL_CANCEL } from '../customer-service/actions';

export type State = {
  readonly loading: boolean;
  orders: Array<any> | null;
  orderUpdateResult: Object | null;
  stopAutoRenewalResult: Object | null;
  resinOrderRefundResult: Object | null;
};

export const reducer = combineReducers<State, RootAction>({
  loading: (state = false, action) => {
    switch (action.type) {
      case ORDER_UPDATE_SUCCESS:
      case ORDER_UPDATE_ERROR:
      case ORDER_UPDATE_CANCEL:
      case RESIN_ORDER_UPDATE_SUCCESS:
      case RESIN_ORDER_UPDATE_ERROR:
      case RESIN_ORDER_UPDATE_CANCEL:
      case RESIN_ORDER_REFUND_SUCCESS:
      case RESIN_ORDER_REFUND_ERROR:
      case RESIN_ORDER_REFUND_CANCEL:
      case CANCEL_STOP_AUTO_RENEW_SUCCESS:
      case CANCEL_STOP_AUTO_RENEW_ERROR:
      case CANCEL_STOP_AUTO_RENEW_CANCEL:
      case SEND_CUSTSERV_EMAIL_SUCCESS:
      case SEND_CUSTSERV_EMAIL_ERROR:
      case SEND_CUSTSERV_EMAIL_CANCEL:
        return false;
      case ORDER_UPDATE_LOADING:
      case RESIN_ORDER_UPDATE_LOADING:
      case RESIN_ORDER_REFUND_LOADING:
      case CANCEL_STOP_AUTO_RENEW_LOADING:
        return action.payload;
      default:
        return state;
    }
  },
  orders: (state = null, action) => {
    switch (action.type) {
      case OMS_LOOKUP_SUCCESS:
        return action.payload.orders;
      default:
        return state;
    }
  },
  orderUpdateResult: (state = null, action) => {
    switch (action.type) {
      case ORDER_UPDATE_SUCCESS:
      case ORDER_UPDATE_ERROR:
      case RESIN_ORDER_UPDATE_SUCCESS:
      case RESIN_ORDER_UPDATE_ERROR:
        return action.payload;
      case ORDER_UPDATE_CANCEL:
      case ORDER_UPDATE_START:
      case RESIN_ORDER_UPDATE_CANCEL:
      case RESIN_ORDER_UPDATE_START:
        return null;
      default:
          return state;
    }
  },
  stopAutoRenewalResult: (state = null, action) => {
    switch (action.type) {
      case CANCEL_STOP_AUTO_RENEW_SUCCESS:
      case CANCEL_STOP_AUTO_RENEW_ERROR:
        return action.payload;
      case CANCEL_STOP_AUTO_RENEW_CANCEL:
      case CANCEL_STOP_AUTO_RENEW_START:
        return null;
      default:
          return state;
    }
  },
  resinOrderRefundResult: (state = null, action) => {
    switch (action.type) {
      case RESIN_ORDER_REFUND_SUCCESS:
      case RESIN_ORDER_REFUND_ERROR:
        return action.payload;
      case RESIN_ORDER_REFUND_CANCEL:
      case RESIN_ORDER_REFUND_START:
        return null;
      default:
          return state;
    }
  },
});
